import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable } from 'rxjs';
import { CommPlan } from '../models/commission/comm-plan.model';
import { environment } from '../../environments/environment';
import { CommPlanDetail } from '../models/commission/comm-plan-detail.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { KomFeed } from '../models/commission/kom-feed.model';
import { ComboDetails } from '../models/commission/combo-details.model';
import { CallDetails } from '../models/commission/call-details.model';
import { MobileFeedModel } from '../models/commission/mobile-feed.model';
import { RntFeedModel } from '../models/commission/rnt-feed.model';
import { RntFeedPage } from '../models/commission/rnt-feed-page.model';
import { EntFeed } from '../models/commission/ent-feed.model';

@Injectable({
    providedIn: 'root'
})
export class KomFeedService {

    host: string = environment.apiUrl + 'komfeed';
    mobilehost: string = environment.apiUrl + 'mobilefeed';
    retentionhost: string = environment.apiUrl + 'retentionfeed';
    entHost: string = environment.apiUrl + 'entfeed';
    tokenId: string = '';
    commModel = new CommPlan();
    kpiDetails: CommPlanDetail[] = [];
    salesChannels: string[] = [];
    commData: CommPlan[] = [];
    komFeedModel = new KomFeed();
    editKomFeedModel = new KomFeed();
    loggedinUser: string = '';
    languages: string[];
    payrollCalender: string[];
    salesRepData: KomFeed[];
    callDetailModel = new CallDetails();

    constructor(private http: HttpClient, private logger: LoggerService, private authgurdService: AuthGaurdService, private authGaurdService: AuthGaurdService) {
        this.tokenId = this.authgurdService.getToken();
    }

    public getAdminConfigTurfData(): Observable<KomFeed[]> {
        return this.http.get<KomFeed[]>(`${this.host}/getturfslist`);
    }

    public getAdminConfigData(): Observable<MobileFeedModel[]> {
        return this.http.get<MobileFeedModel[]>(`${this.mobilehost}/getadminconfigdata`);
    }

    public getMobileFeedSerchResults(mobileFeedModel: MobileFeedModel): Observable<MobileFeedModel[]> {
        return this.http.post<MobileFeedModel[]>(`${this.mobilehost}/getmobilefeedresults`, mobileFeedModel);
    }
    public getRntFeedSearchResults(rntFeedModel: RntFeedModel): Observable<RntFeedPage> {
        return this.http.post<RntFeedPage>(`${this.retentionhost}/getrntfeedresults`, rntFeedModel);
    }
    public getRntFilterOptions(): Observable<any> {
        return this.http.get<any>(`${this.retentionhost}/getrntfilteroptions`);
    }
    public updateRntFeedByID(rntFeedModel: RntFeedModel): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.retentionhost}/updaterntfeed`, rntFeedModel);
    }
    public deleteRntFeedById(retId: number): Observable<CustomHttpRespone> {
        return this.http.delete<CustomHttpRespone>(`${this.retentionhost}/deleterntfeed/${retId}`);
    }
    public getMobileFeedDataById(id: number): Observable<MobileFeedModel> {
        return this.http.get<MobileFeedModel>(`${this.mobilehost}/getmobilefeedatabyid` + '/' + id);
    }
    public updateMobileFeedByID(mobileFeedModel: MobileFeedModel): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.mobilehost}/updatemobilefeed`, mobileFeedModel);
    }

    public addMobileFeed(mobileFeedModel: MobileFeedModel): Observable<MobileFeedModel> {
        return this.http.post<MobileFeedModel>(`${this.mobilehost}/addobilefeed`, mobileFeedModel);
    }



    public deleteRowByWipByinfoId(id: number): Observable<CustomHttpRespone> {
        let url = this.host + '/deleterowbywipbyinfoid/' + id;
        return this.http.delete<CustomHttpRespone>(url);
    }
    public getProduct(comboDtl: ComboDetails): Observable<ComboDetails> {
        return this.http.post<ComboDetails>(`${this.host}/getproduct`, comboDtl);
    }
    public getSalesRepIds(feedData: KomFeed): Observable<KomFeed[]> {
        return this.http.post<KomFeed[]>(`${this.host}/getsalesrepids`, feedData);
    }
    public getFeedSerchResults(komFeedModel: KomFeed): Observable<KomFeed[]> {
        return this.http.post<KomFeed[]>(`${this.host}/getfeedresults`, komFeedModel);
    }
    public getEnterpriseResults(entFeedModel: EntFeed): Observable<EntFeed[]> {
        return this.http.post<EntFeed[]>(`${this.entHost}/getEnterpriseResults`, entFeedModel);
    }
    public getEntReleaseResults(entFeedModel: EntFeed): Observable<EntFeed[]> {
        return this.http.post<EntFeed[]>(`${this.entHost}/getEntReleaseResults`, entFeedModel);
    }
    public getFeedSerchResultsExcel(komFeedModel: KomFeed): Observable<KomFeed[]> {
        return this.http.post<KomFeed[]>(`${this.host}/getfeedresultsexcel`, komFeedModel);
    }
    public getEntFeedSerchResultsExcel(entFeedModel: EntFeed): Observable<EntFeed[]> {
        if(entFeedModel.isEnterprise){
            return this.http.post<EntFeed[]>(`${this.entHost}/getEnterpriseResultsExcel`, entFeedModel);
        }
        return this.http.post<EntFeed[]>(`${this.entHost}/getEntReleaseResultsExcel`, entFeedModel);
    }
    public saveWibByInfoData(komFeedModel: KomFeed): Observable<KomFeed> {
        return this.http.post<KomFeed>(`${this.host}/savewipbyifodata`, komFeedModel);
    }
    public saveWibByInfoDataENT(entFeedModel: EntFeed): Observable<EntFeed> {
        return this.http.post<EntFeed>(`${this.host}/saveWipByifoDataEnt`, entFeedModel);
    }

    public getProductNames(komFeedModel: KomFeed): Observable<ComboDetails[]> {
        return this.http.post<ComboDetails[]>(`${this.host}/getproductnames`, komFeedModel);
    }
    public getProductInfo(productName: string, komFeedModel: KomFeed): Observable<ComboDetails[]> {
        return this.http.post<ComboDetails[]>(`${this.host}/getproductinfo` + '/' + productName, komFeedModel);
    }
    public getProductInfo1(komFeedModel: KomFeed): Observable<ComboDetails[]> {
        return this.http.post<ComboDetails[]>(`${this.host}/getproductinfo1`, komFeedModel);
    }
    public updateKomFeedByID(komFeedModel: KomFeed): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.host}/updatekomfeed`, komFeedModel);
    }
    public updateEntFeedByID(entFeedModel: EntFeed): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.entHost}/updateEntFeed`, entFeedModel);
    }
    public updateEntReleaseByID(entFeedModel: EntFeed): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.entHost}/updateEntRelease`, entFeedModel);
      }

    public getKomFeedDataById(id: number): Observable<KomFeed> {
        return this.http.get<KomFeed>(`${this.host}/getkomfeedatabyid` + '/' + id);
    }

    public getEntFeedDataByEntFeedId(id: number): Observable<EntFeed> {
        return this.http.get<EntFeed>(`${this.entHost}/getEntFeedDataByEntFeedId` + '/' + id);
    }

    public getKomFeedDataByCorpHouseRep(corp: number, house: string, salesrepid: string): Observable<KomFeed> {
        return this.http.get<KomFeed>(`${this.host}/getkomfeedatabycorphouserepid` + '/' + corp + '/' + house + '/' + salesrepid);
    }
    public getKomFeedDataByRepId(corp: number, house: string, salesrepid: string, id: number): Observable<KomFeed[]> {
        return this.http.get<KomFeed[]>(`${this.host}/getkomfeedatabyrepid` + '/' + corp + '/' + house + '/' + salesrepid + '/' + id);
    }
    public getEntFeedDataBySearch(id: number): Observable<EntFeed[]> {
        return this.http.get<EntFeed[]>(`${this.entHost}/getEntFeedDataBySearch` + '/' + id);
    }
    public getRateCodeInfo(corp: number, ratecd: string, orderdt: Date): Observable<KomFeed[]> {
        return this.http.get<KomFeed[]>(`${this.host}/getratecodeinfo` + '/' + corp + '/' + ratecd + '/' + orderdt);
    }

    public getReportingCentersInfo(corp: number, ratecd: string, orderdt: Date): Observable<KomFeed[]> {
        return this.http.get<KomFeed[]>(`${this.host}/getreportingcentersinfo` + '/' + corp + '/' + ratecd + '/' + orderdt);
    }

    public getOOLDetails(): Observable<KomFeed[]> {
        return this.http.get<KomFeed[]>(`${this.host}/getooldetails`);
    }
    public addNewAdjustment(komFeedModel: KomFeed): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/addnewadjustment`, komFeedModel);
    }
    public addNewEntAdjustment(entFeedModel: EntFeed): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.entHost}/addnewadjustment`, entFeedModel);
    }
    public addAdjustment(komFeedModel: KomFeed): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/addadjustment`, komFeedModel);
    }
    public getCallDataResult(callDtlMdl: CallDetails): Observable<CallDetails[]> {
        return this.http.post<CallDetails[]>(`${this.host}/getCallData`, callDtlMdl);
    }
    public deleteCallByKomCallID(id: number): Observable<CustomHttpRespone> {
        let url = this.host + '/deletecallbykomcallid/' + id;
        return this.http.delete<CustomHttpRespone>(url);
    }
    public saveCallDtl(callDetailMdl: CallDetails): Observable<CallDetails> {
        return this.http.post<CallDetails>(`${this.host}/savecalldetails`, callDetailMdl);
    }
    public updateCallDtls(editCallDetailMdl: CallDetails): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.host}/updatecalldetails`, editCallDetailMdl);
    }
}